import { observer } from "mobx-react";
import { useStore } from "../../../../app/data/root.store";
import { colors } from '../../../../../common/styles/theme.styles';
import { VaultModalHeader, VaultModalContent, VaultModalFooter, VaultActionButton, VaultWarningMessage } from './SharedModalComponents';
import { BaseModal } from "../../../../../common/components/BaseModal/BaseModal";
import { PeriodEditor } from "../../VaultMetadataPanel/MetadataLabelsSection/PeriodTagCategory/PeriodEditor";
import { useEffect, useState } from "react";

export const PeriodEditModal = observer(({ onClose, onSave }) => {
    const { vaultStore } = useStore();
    const [periodTag, setPeriodTag] = useState(null);

    useEffect(() => {
        setPeriodTag(vaultStore.commonPeriodsAcrossSelectedFiles);
    }, [vaultStore.commonPeriodsAcrossSelectedFiles]);

    const handleSave = () => onSave([periodTag]);

    const getModalTitle = () => {
        const count = vaultStore.selectedFilesForBulkEdit.length;
        return `Edit selected item${count === 1 ? '' : 's'} (${count})`;
    };

    return (
        <BaseModal width="600px" borderRadius={12} onBackDropClick={onClose}>
            <VaultModalHeader onClose={onClose}>
                {getModalTitle()}
            </VaultModalHeader>

            <VaultModalContent>
                <PeriodEditor
                    tag={periodTag}
                    onChange={setPeriodTag}
                    onSave={handleSave}
                    onCancel={onClose}
                />

                <VaultWarningMessage>
                    This action will replace all existing periods with the selected periods for all selected files.
                </VaultWarningMessage>
            </VaultModalContent>

            <VaultModalFooter>
                <VaultActionButton
                    onClick={handleSave}
                    backgroundColor={colors.darkGray1}
                    whiteText
                >
                    Save
                </VaultActionButton>
            </VaultModalFooter>
        </BaseModal>
    );
}); 